<template>
<div class="scrolly-content-image">
  <img v-for="index in attributes.p.length" :key="index"
    :src="getSource(index)"
    :style="getImageStyle(index)" />
</div>
</template>

<script>
export default {
  props: ['attributes', 'enter'],
  computed: {
    isTabletWidth () {
      return this.$window.innerWidth < 768
    },
    hasDesktopSource () {
      const {hasdesktop} = this.attributes
      return !hasdesktop || hasdesktop !== 'false'
    }
  },
  methods: {
    getImagePath (index) {
      let [root, ext = 'jpg'] = this.attributes.value.split('.')
      return root + index + '.' + ext
    },
    getImageStyle (index) {
      return {
        opacity: index === 1 ? 1 : this.enter(index - 1, 200)
      }
    },
    getSource (index) {
      const {isTabletWidth, hasDesktopSource} = this
      let [path, ext = 'jpg'] = this.attributes.value.split('.')
      path += '/' + index + (!isTabletWidth && hasDesktopSource ? '-desktop.' : '.') + ext
      return require(`images/${path}`)
    }
  }
}
</script>

<style lang="scss">
.scrolly-content-image {
  img {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100%;
  }
}
</style>
